import { Component } from 'solid-js'

const NovelTtsSettings: Component<{}> = () => {
  return (
    <>
      <div class="text-xl">NovelAI Text To Speech</div>

      <div class="italic">You can configure the NovelAI key in the AI Settings.</div>
    </>
  )
}

export default NovelTtsSettings
